import { render, staticRenderFns } from "./CompanyPage.vue?vue&type=template&id=0f1cc179&scoped=true"
import script from "./CompanyPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./CompanyPage.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./CompanyPage.vue?vue&type=style&index=0&id=0f1cc179&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f1cc179",
  null
  
)

export default component.exports